/**
 * Duplázó függvény, hogy ne kelljen a magic-numberrel szenvednünk.
 * @param {number} num - A szám, amit duplázni akarunk.
 * @returns {number} A szám kétszerese.
 */
module.exports.double = function double (num) {
  return num * 2
}
